import Model, { attr, belongsTo } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type Student from 'teacher-ui-client/models/student'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type NumberTransform from 'teacher-ui-client/transforms/number'

export default class ReadAloudReview extends Model {
  @attr<StringTransform>('string') declare assignmentUuid: string

  // out of 5
  @attr<NumberTransform>('number') declare score: number

  @attr<NumberTransform>('number') declare wordsPerMinute?: number

  @attr<StringTransform>('string') declare comments?: string

  // optional, since review may be for a deleted student
  @belongsTo<Student>('student', { async: false, inverse: null }) declare student?: Student;

  [Type] = 'read-aloud-review' as const
}
